import { Text } from '@mantine/core'

const DetailRow = ({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) => (
  <div className="flex items-center justify-between">
    <Text size="xs" fw={300} component="span">
      {label}
    </Text>
    <Text size="xs" fw={300} component="span">
      {children}
    </Text>
  </div>
)

export default DetailRow
